import type { SVGProps } from 'react';
const DawnFlagCF = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect
      width={21.5}
      height={15.5}
      x={0.25}
      y={0.25}
      fill="#fff"
      stroke="#F5F5F5"
      strokeWidth={0.5}
      rx={1.75}
    />
    <mask
      id="dawn-flag-CF_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-CF_svg__a)">
      <path fill="#083D96" d="M0 4.267h22V0H0z" />
      <path fill="#37AE39" d="M0 11.733h22V7.467H0z" />
      <path fill="#FFD13F" d="M0 16h22v-4.267H0z" />
      <path fill="#E42346" d="M8.38 16h5.239V0H8.381z" />
      <path
        fill="#FFD03B"
        d="m3.667 2.757-.924.67.341-1.1-.911-.688 1.134-.01.36-1.096.36 1.096 1.135.01-.912.687.34 1.102z"
      />
    </g>
  </svg>
);
export default DawnFlagCF;
